import { SocialMediaMarketingService } from '@naturalcycles/shared'

export const socialMediaMarketingService = new SocialMediaMarketingService()
